import { Component } from '@angular/core';
import { EventsService } from 'src/app/core/services/events.service';
import { GoogleMapOptionsEvents } from 'src/app/core/events/events';

@Component({
    selector: 'aa-traffic-alert-last-updated',
    templateUrl: './traffic-alert-last-updated.component.html',
    styleUrls: ['./traffic-alert-last-updated.component.scss'],
    standalone: false
})
export class TrafficAlertLastUpdatedComponent {

  public lastUpdatedTrafficTime: string;

  constructor(private eventsService: EventsService) {
    this.eventsService.on(GoogleMapOptionsEvents.TRAFFIC_ALERT_UPDATED, this.onTrafficAlertUpdated);
  }

  onTrafficAlertUpdated = (event: any) => {
    this.lastUpdatedTrafficTime = event;
  }
}
